import { DateTime } from 'luxon';
import { ILineItem } from '../ILineItem';
import React, { useState } from 'react';
import { Tooltip } from 'ui-toolkit/components/Tooltip/Tooltip';
import { BodyText } from 'ui-toolkit/components/Typography/basicTypography';
import { faFile } from '@fortawesome/pro-solid-svg-icons';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { PDFPreview } from '../../../../ui-toolkit/components/PDFPreview';
import { createDownloadDocumentUrl } from '../../../../API/order/documents/adminDocumentsAPI';
import { IStandardDocumentVersionData } from '../../../../types/order/documents/shared/interfaces';
import { ButtonDropdown, IDropdownAnchor } from '../../../../ui-toolkit';
import { StyledDocumentIcon } from '../edit/lineItem/Fee.styles';
import { OptionalLinkTW } from 'tailwindComponents/link/OptionalLinkTW';

const convertDateStringToDisplayDate = (value: string) => {
  const date = DateTime.fromISO(value);
  return `${date.month}/${date.day}/${date.year}`;
};

export interface INameColumnProps {
  columnValue: any;
  fee?: ILineItem;
  editUrl?: string;
}

const getGridLayout = (dateFrom: boolean, dateTo: boolean, goodThruDate: boolean, docs: boolean) => {
  if ((dateFrom && dateTo) || goodThruDate) {
    return 'auto 100px 24px';
  }
  if (docs) {
    return 'auto 24px';
  }
  return 'auto';
};

export const NameColumn: React.FC<INameColumnProps> = ({ columnValue, fee, editUrl }) => {
  const dateFrom = fee?.stringSettlementStatementPropertyValues[eFeePropertyNames.DateFrom];
  const dateTo = fee?.stringSettlementStatementPropertyValues[eFeePropertyNames.DateTo];
  const goodThruDate = fee?.stringSettlementStatementPropertyValues[eFeePropertyNames.GoodThruDate];
  const [previewPDF, setPreviewPDF] = useState<IStandardDocumentVersionData | undefined>(undefined);

  const PDFPreviewDocuments =
    (fee?.documents && fee?.documents.map((t) => ({ children: t.fileName, onClick: () => setPreviewPDF(t) }))) || [];

  const gridTemplateColumns = getGridLayout(!!dateFrom, !!dateTo, !!goodThruDate, !!fee?.documents?.length);
  return (
    <div className={'grid columns-2 items-start gap-1 self-start p-4 text-base'} style={{ gridTemplateColumns }}>
      <OptionalLinkTW to={editUrl}>
        <div className={'font-medium'}>{columnValue || '--'}</div>
        {((dateFrom && dateTo) || goodThruDate) && (
          <div>
            {dateFrom && dateTo && (
              <div>
                {convertDateStringToDisplayDate(dateFrom)} to {convertDateStringToDisplayDate(dateTo)}
              </div>
            )}
            {goodThruDate && (
              <div>
                <Tooltip placement={'bottom'} trigger={'hover'} tooltipContent={<BodyText>Good Through Date</BodyText>}>
                  {convertDateStringToDisplayDate(goodThruDate)}
                </Tooltip>
              </div>
            )}
          </div>
        )}
      </OptionalLinkTW>
      {!!fee?.documents?.length && (
        <div className={'grid justify-center'}>
          <ButtonDropdown intent={'ghost'} isInline items={PDFPreviewDocuments} anchor={IDropdownAnchor.bottomCenter}>
            <StyledDocumentIcon data-test-id={'document-icon'} icon={faFile} />
          </ButtonDropdown>
        </div>
      )}
      {previewPDF && (
        <PDFPreview
          file={createDownloadDocumentUrl(previewPDF.id, previewPDF.versionId)}
          onClose={() => setPreviewPDF(undefined)}
        />
      )}
    </div>
  );
};
